module.exports = __webpack_public_path__ + "img/tu4.fd003a10.png";